import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo.png';

const _withScopeId = n => (_pushScopeId("data-v-049e9612"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header-mobile"
};
const _hoisted_2 = {
  class: "left"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "uniAccount",
  class: "logo"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "下载中心", -1));

const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  class: "right"
};
import MobileMenuIcon from '../icon/mobile-menu-icon.vue';
import UserMenu from './user-menu.vue';
import NavbarMenu from './navbar-menu.vue';
import useUserStore from '@/store/modules/user.js';
import { USER_LOGIN_IP } from '@/service/request/config.js';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'header-mobile',

  setup(__props) {
    const router = useRouter();
    const userMenuRef = ref(null);
    const navbarMenuRef = ref(null);

    const handleUserMenuOpen = () => {
      userMenuRef.value.drawerVisible = true;
    };

    const handleMenuOpen = () => {
      navbarMenuRef.value.drawerVisible = true;
    };

    const userStore = useUserStore();

    const handleLogin = () => {
      const currentUrl = window.location.href;
      window.location.href = USER_LOGIN_IP + '/login?org=comentropy&app=download_center&goto=' + currentUrl; // window.location.href =
      //   'https://www.uniaccount.org/login?org=comentropy&app=download_center&goto=' +
      //   currentUrl
    };

    const handleTo = path => {
      router.push(path);
    };

    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(MobileMenuIcon, {
        onClick: handleMenuOpen
      }), _createVNode(NavbarMenu, {
        ref_key: "navbarMenuRef",
        ref: navbarMenuRef
      }, null, 512)]), _createElementVNode("div", {
        class: "center",
        onClick: _cache[0] || (_cache[0] = $event => handleTo('/item-list'))
      }, _hoisted_5), _createElementVNode("div", _hoisted_6, [_unref(userStore).token ? (_openBlock(), _createBlock(_component_el_avatar, {
        key: 0,
        size: "small",
        src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        onClick: handleUserMenuOpen
      })) : _createCommentVNode("", true), !_unref(userStore).token ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "login-btn",
        onClick: handleLogin
      }, " 登录 ")) : _createCommentVNode("", true), _createVNode(UserMenu, {
        ref_key: "userMenuRef",
        ref: userMenuRef
      }, null, 512)])]);
    };
  }

};